import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';

@Component({
    selector: 'app-loading[type]',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.css']
})
@TraceClassDecorator()
export class LoadingComponent implements OnInit {
    readonly type_labels: string[] = [
        'LOADING_DATA',
        'POSTING_DATA',
        'SMALL_LOADER'
    ];
    @Input('type')
    type: string = '';

    constructor() {}

    ngOnInit() {
        if (!Boolean(this.type)) {
            throw new TypeError(`Attribute 'type' is required`);
        }
        if (Boolean(this.type) && !this.type_labels.includes(this.type)) {
            throw new TypeError(`Attribute 'type' is not correct one`);
        }
    }
}
